import { render, staticRenderFns } from "./WalletCreateProvider.vue?vue&type=template&id=753089b4&"
import script from "./WalletCreateProvider.vue?vue&type=script&lang=ts&"
export * from "./WalletCreateProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports